const modern = function () {
    $('.table-responsive tbody tr').slice(-2).find('.dropdown').addClass('dropup');
};

export default modern;


